import Vue from 'vue';
import VueRouter from 'vue-router';

const ProductSelectionApp = () =>
  import(
    /* webpackChunkName: "ProductSelectionApp" */
    '@components/BookingBusinessListing/ProductSelectionApp.vue'
  );
const FormApp = () =>
  import(
    /* webpackChunkName: "FormApp" */
    '@components/BookingBusinessListing/FormApp.vue'
  );
const AdditionalOptionsApp = () =>
  import(
    /* webpackChunkName: "AdditionalOptionsApp" */
    '@components/BookingBusinessListing/AdditionalOptionsApp.vue'
  );
const SummaryApp = () =>
  import(
    /* webpackChunkName: "SummaryApp" */
    '@components/BookingBusinessListing/SummaryApp.vue'
  );

const AdvertisementProductSelectionApp = () =>
  import(
    /* webpackChunkName: "AdvertisementProductSelectionApp" */
    '@components/BookingAdvertisement/ProductSelectionApp.vue'
  );
const AdvertisementFormApp = () =>
  import(
    /* webpackChunkName: "AdvertisementFormApp" */
    '@components/BookingAdvertisement/FormApp.vue'
  );
const AdvertisementPaymentSelection = () =>
  import(
    /* webpackChunkName: "AdvertisementPaymentSelection" */
    '@components/BookingAdvertisement/PaymentSelectionApp.vue'
  );
const AdvertisementSummaryApp = () =>
  import(
    /* webpackChunkName: "AdvertisementSummaryApp" */
    '@components/BookingAdvertisement/SummaryApp.vue'
  );

const InstitutionUpgradeBillingAddress = () =>
  import(
    /* webpackChunkName: "InstitutionUpgradeBillingAddress" */
    '@components/Institution/Upgrade/BillingAddress.vue'
  );
const InstitutionUpgradeSummary = () =>
  import(
    /* webpackChunkName: "InstitutionUpgradeSummary" */
    '@components/Institution/Upgrade/Summary.vue'
  );

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/institution/upgrade/billing-address',
      component: InstitutionUpgradeBillingAddress,
    },
    {
      path: '/institution/upgrade/summary',
      component: InstitutionUpgradeSummary,
    },
    { path: '/booking', component: ProductSelectionApp },
    { path: '/booking/', component: ProductSelectionApp },
    { path: '/booking/form', component: FormApp },
    {
      path: '/booking/options',
      component: AdditionalOptionsApp,
    },
    {
      path: '/booking/summary',
      component: SummaryApp,
    },
    {
      path: '/booking-advertisement',
      component: AdvertisementProductSelectionApp,
    },
    {
      path: '/booking-advertisement/',
      component: AdvertisementProductSelectionApp,
    },
    {
      path: '/booking-advertisement/form',
      component: AdvertisementFormApp,
    },
    {
      path: '/booking-advertisement/options',
      component: AdvertisementPaymentSelection,
    },
    {
      path: '/booking-advertisement/summary',
      component: AdvertisementSummaryApp,
    },
  ],
});
